module.exports = __webpack_public_path__ + "static/media/13.200fda4e.png";